export default "__VITE_ASSET__DkqdZ0p0__";